/* ORDERS */
export const GET_ORDERS = "GET_ORDERS"
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS"
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL"


/* GET_ORDER_DETAIL */
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL"
export const GET_ORDER_DETAIL_SUCCESS = "GET_ORDER_DETAIL_SUCCESS"
export const GET_ORDER_DETAIL_FAIL = "GET_ORDER_DETAIL_FAIL"

/*  */
export const GET_AUTH_USER = "GET_AUTH_USER"
export const GET_AUTH_USER_FAIL = "GET_AUTH_USER_FAIL"
export const GET_AUTH_USER_SUCCESS = "GET_AUTH_USER_SUCCESS"

/**
 * add ORDER
 */
 export const ADD_NEW_ORDER = "ADD_NEW_ORDER"
 export const ADD_ORDER_SUCCESS = "ADD_ORDER_SUCCESS"
 export const ADD_ORDER_FAIL = "ADD_ORDER_FAIL"
 
 /**
  * Edit ORDER
  */
 export const UPDATE_ORDER = "UPDATE_ORDER"
 export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS"
 export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL"
 
 /**
  * Delete ORDER
  */
 export const DELETE_ORDER = "DELETE_ORDER"
 export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS"
 export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL"

 export const CONVERT_TO_ORDER = "CONVERT_TO_ORDER"
 export const CONVERT_TO_ORDER_SUCCESS = "CONVERT_TO_ORDER_SUCCESS"
 export const CONVERT_TO_ORDER_FAIL = "CONVERT_TO_ORDER_FAIL" 
 

